import { action, computed, observable, makeObservable } from 'mobx';
import {SuccessResponse, userLoaders} from '../../../../domain';
import {HttpPromiseState, StringControl, validators} from '../../../../lib/helpers';

export class UpdatePasswordStore {
  oldPassword: StringControl = new StringControl('', '', validators.required);
  newPassword: StringControl = new StringControl('', '', validators.required);
  repeatNewPassword: StringControl = new StringControl('', '');

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null = null;

  constructor() {
    makeObservable(this);
  }

  @computed
  get repeatNewPasswordFgName() {
    const showError = this.repeatNewPassword.touched &&
      this.repeatNewPassword.value !== this.newPassword.value;
    return showError ? 'form-group has-error' : 'form-group';
  }

  @computed
  get valid() {
    return this.oldPassword.valid &&
      this.newPassword.valid &&
      this.newPassword.value === this.repeatNewPassword.value;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.oldPassword.markTouched();
    this.newPassword.markTouched();
    this.repeatNewPassword.markTouched();
    if (!this.valid)
      return;
    this.save = userLoaders.updateMyPassword(this.oldPassword.value, this.newPassword.value);
  }
}
